<script setup lang="ts">
const NOT_FOUND_IMG = 'https://resources1.interface003.com/web30/2026/06/25/4a80ef9a-f964-40d1-8e6f-5e79e6c3ec7f.png'

const { localePath, t } = useAppI18n()

/**
 * 优先返回上一页；如果没有可用历史记录，则回到站点首页。
 * @returns 返回路由跳转 Promise。
 */
const handleBackHome = async () => {
  if (import.meta.client && window.history.length > 1) {
    return window.history.back()
  }

  return await navigateTo(
    localePath({
      name: 'home',
    }),
  )
}
</script>

<template>
  <section
    class="flex min-h-[calc(100vh-317px)] w-full flex-col items-center justify-center gap-[24px] px-[20px] py-[40px] pt-[70px] text-center sm:px-[24px] sm:py-[48px]"
  >
    <CommonImage :src="NOT_FOUND_IMG" alt="404" class="h-[198px] w-[350px] shrink-0" loading="eager" />

    <div class="flex w-full max-w-[350px] flex-col items-center gap-[8px]">
      <h2 class="w-full text-center text-[20px] leading-[28px] font-semibold text-[#1D2129]">
        {{ t('84589') }}
      </h2>
      <p class="w-full text-center text-[16px] leading-[24px] font-normal text-[#86909C]">
        {{ t('84588') }}
      </p>
    </div>

    <button
      class="not-found-btn flex h-[46px] min-w-[128px] cursor-pointer items-center justify-center rounded-[100px] bg-[#112D73] px-[16px] text-center text-[16px] leading-[24px] font-semibold text-[#FFFFFF] transition-colors duration-300"
      type="button"
      @click="handleBackHome"
    >
      {{ t('84038') }}
    </button>
  </section>
</template>

<style scoped>
.not-found-btn:hover {
  background: linear-gradient(0deg, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0.08) 100%), #112d73;
}
</style>
